import classNames from 'classnames';
import React from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';

import Checkbox from './Form/Checkbox';
import Radio from './Form/Radio';
import Input from './Form/Input';
import Select from './Form/Select';
import Submit from './Form/Submit';
import Textarea from './Form/Textarea';
import TranslatedField from './Form/TranslatedField';
import ZipCode from './Form/ZipCode';
import PurchaseLocationSelector from './Form/PurchaseLocationSelector';

export {
  Field,
  TranslatedField,
  reduxForm,
  SubmissionError,
  Checkbox,
  Radio,
  Input,
  Select,
  Submit,
  Textarea,
  ZipCode,
  PurchaseLocationSelector,
};

export const Form = props => (
  <form className={classNames('Form', props.className)} {...props}>
    {props.children}
  </form>
);
